import React from 'react';
import './index.css'; // Import the CSS file
import { Link } from 'react-router-dom';
import FloatingWhatsAppButton from '../whatsappicon';
import FloatingCallButton from '../callicon';

const TaskBar = () => {
  return (
    <div className="task-bar-container">
      <div className="section">
        <h3>Explore</h3>
        <Link to="/about">About Us</Link>
        <Link to="/contact">Contact Us</Link>
        <Link to="/services">Services</Link>
        <Link to="/login">Login</Link>
      </div>

      <div className="section">
        <h3>Quick links</h3>
        <Link to="/countries/australia">Australia</Link>
        <Link to="/countries/united-kingdom">United Kingdom</Link>
        <Link to="/countries/united-states">United States</Link>
        <Link to="/countries/canada">Canada</Link>
        <Link to="/countries/france">France</Link>
        <Link to="/countries/germany">Germany</Link>
        <Link to="/countries/new-zealand">New zealand</Link>
      </div>

      <div className="section">
        <h3>Our Offices</h3>
        <Link to="">Hyderabad</Link>
        <Link to="">Warangal</Link>
        <Link to="">Khammam</Link>
        <Link to="">Kothagudem</Link>
        <Link to="">Vijayawada</Link>
        <Link to="">Nellore</Link>
        <Link to="">Ongole</Link>
      </div>

      {/* <div className="section">
        <h3>Free Guidance</h3>
        <a href="/articles-videos">Articles & Videos</a>
        <a href="/podcast">The NN/g UX Podcast</a>
      </div>

      <div className="section">
        <h3>About</h3>
        <a href="/why-nng">Why NN/g</a>
        <a href="/about-us">About Us</a>
        <a href="/people">People</a>
        <a href="/clients">Clients</a>
      </div> */}

      <div className="social-links-container">
        <h3>Follow Us On</h3>
        <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
          <img src="https://tse1.mm.bing.net/th/id/OIP.NN_29U5mI6l_KAfhsxQksgHaHa?rs=1&pid=ImgDetMain" alt="LinkedIn" />
          <span>LinkedIn</span>
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src="https://psfonttk.com/wp-content/uploads/2020/09/Instagram-Logo-PNG.png" alt="Instagram" />
          <span>Instagram</span>
        </a>
        <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
          <img src="https://www.interstellarrift.com/wiki/images/d/d8/Youtube-logo-png-photo-0.png" alt="YouTube" />
          <span>YouTube</span>
        </a>
        {/* <a href="https://example.com/podcast" target="_blank" rel="noopener noreferrer">
          <span>Podcast</span>
        </a>
        <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
          <img src="/twitter_icon.png" alt="X (Twitter)" />
          <span>X (Twitter)</span>
        </a>
        <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
          <img src="/facebook_icon.png" alt="Facebook" />
          <span>Facebook</span>
        </a> */}
      </div>
      <FloatingWhatsAppButton />
      <FloatingCallButton />
    </div>
  );
};

export default TaskBar;